export default __webpack_public_path__ + "static/media/hosting_top.a19e043f.jpg";